
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import {findUsersByEmail} from '@/services/helpdeskUserLookup';

// Muted, high-contrast tones so white initials stay readable.
const PALETTE = ['#0055cc', '#216e4e', '#5e4db2', '#a54800', '#ae2e24', '#206a83', '#44546f', '#7f5f01'];

// "pol.pujado@x.com" → "Pol Pujado": shown until (or instead of) the mayordomo name.
export function nameFromEmail(email: string): string {
  const local = (email || '').split('@')[0].replace(/\+.*$/, '');
  const words = local.split(/[._-]+/).filter(Boolean);
  return words.length ? words.map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ') : email;
}

export function colorForEmail(email: string): string {
  let h = 0;
  for (let i = 0; i < (email || '').length; i++) h = (h * 31 + email.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
}

@Component({name: 'HelpdeskAssignee'})
export default class HelpdeskAssignee extends Vue {
  @Prop({default: ''}) email!: string;
  @Prop({type: Boolean, default: false}) large!: boolean;
  @Prop({type: Boolean, default: false}) hideName!: boolean;
  @Prop({type: Boolean, default: false}) compact!: boolean;

  resolvedName = '';

  get name(): string {
    return this.resolvedName || nameFromEmail(this.email);
  }

  get initials(): string {
    const parts = this.name.trim().split(/\s+/);
    return ((parts[0] || '').charAt(0) + (parts.length > 1 ? parts[parts.length - 1].charAt(0) : '')).toUpperCase() || '?';
  }

  get color(): string {
    return colorForEmail((this.email || '').toLowerCase());
  }

  @Watch('email', {immediate: true})
  onEmailChanged(email: string) {
    this.resolvedName = '';
    if (!email) return;
    findUsersByEmail(email).then((users) => {
      if (email !== this.email || !users.length) return;
      const u = users[0];
      this.resolvedName = ((u.first_name || '') + ' ' + (u.last_name || '')).replace(/\s+/g, ' ').trim();
    });
  }
}
